import { useMemo } from "react";
import CompanyService from "../../../../services/CompanyService";
import { TranslationService } from "../../../../services/TranslationService";
import Dropdown from "../../../shared/components/Dropdown";
import { EditProps } from "../EditAction";
import { Field } from "./FieldHelpers";
import { ActionType } from "../../../../services/ActionService";

export const ActivityType = ({ setField, data }: EditProps) => {
  const activityTypeOptions = useMemo(
    () =>
      CompanyService.getActivityTypes()
        .filter((x) =>
          // WhatsApp usa los mismos tipos de gestión que el modal de WhatsApp (flag SMS)
          data.Type === ActionType.ActionSMSSend ||
          data.Type === ActionType.ActionSendWhatsApp
            ? x.SMS
            : x.Mail
        )
        .map((x) => ({ value: x.ActivityTypeID, text: x.ActivityTypeName })),
    [data.Type]
  );

  // Se comenta porque en V1 funciona asi. La opcion por defecto de la configuracion no es tenida en cuenta en esta pantalla.
  // const defaultType = useMemo(() =>
  //     CompanyService.getActivityTypes()
  //         .filter(x => data.Type === ActionType.ActionSMSSend ? x.SMS : data.Type === ActionType.MailSend ? x.Mail : x.Task)
  //         .find(x =>
  //             data.Type === ActionType.ActionSMSSend ?
  //                 x.SMSDefault :
  //                 data.Type === ActionType.MailSend ?
  //                     x.MailDefault :
  //                     x.TaskDefault
  //         )?.ActivityTypeID, [data.Type]);

  if (activityTypeOptions.length === 0) {
    return <></>;
  }

  return (
    <Field title={TranslationService.translate.ActivityType2}>
      <Dropdown
        onChange={setField("ActivityTypeID")}
        items={activityTypeOptions}
        optionLabel={TranslationService.translate.None}
        defaultValue={data.ActivityTypeID}
      />
    </Field>
  );
};
